module.exports = __webpack_public_path__ + "img/bags-small.56f76046.jpg";